import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { HttpService } from './http.service';

@Injectable()
export class mailSeriveApi {
    constructor(private api: HttpService) { }
    
    post(data: any):Observable<any>{
        let headers = new HttpHeaders();
        headers.append('Content-Type', 'applications/json');
        return this.api.mailPost(data, {headers});
    }

}
